var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_9561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.3335C5.42065 1.3335 3.33398 3.42016 3.33398 6.00016C3.33398 9.50016 8.00065 14.6668 8.00065 14.6668C8.00065 14.6668 12.6673 9.50016 12.6673 6.00016C12.6673 3.42016 10.5807 1.3335 8.00065 1.3335ZM4.66732 6.00016C4.66732 4.16016 6.16065 2.66683 8.00065 2.66683C9.84065 2.66683 11.334 4.16016 11.334 6.00016C11.334 7.92016 9.41398 10.7935 8.00065 12.5868C6.61398 10.8068 4.66732 7.90016 4.66732 6.00016Z",
    fill: "#6F747A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 7.66683C8.92113 7.66683 9.66732 6.92064 9.66732 6.00016C9.66732 5.07969 8.92113 4.3335 8.00065 4.3335C7.08018 4.3335 6.33398 5.07969 6.33398 6.00016C6.33398 6.92064 7.08018 7.66683 8.00065 7.66683Z",
    fill: "#6F747A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_9561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationc);
export default __webpack_public_path__ + "static/media/locationc.af53d09a0a1440fbba1fcd400841560a.svg";
export { ForwardRef as ReactComponent };